export default __webpack_public_path__ + "static/media/caroline.572d13c8.jpg";